// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"3093":"list","3180":"story"}[chunkId] || chunkId) + "-" + {"3093":"ae90920b0252d8ac8bf1","3180":"350446b1247d592beff2","9277":"969b3e198271105ecce2"}[chunkId] + ".css";
};